import ReactDOM from "react-dom/client";
import "./index.scss";
import { bootstrapApp } from "./bootstrap";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

void bootstrapApp(root);
